import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import styles from "../../../Announcements/Announcement.module.css";
import style from "../../BookModule.module.css";
import { styled } from "@mui/material/styles";
import ListInfo from "../../../CourseInfo/Course/CourseInfoCreate.module.css";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { AxiosInstance } from "../../../../../../axios";
import Loader from "../../../../Loader";
import Pagination from "../../../../../ReusuableComponent/Pagination/Pagination";
import ViewIcon from "../BookTabs/ViewIcon.png";
import CustomDownloadButton from "../../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
import DatePickerSample from "../../../../DatePicker";
import toast from "react-hot-toast";

const RewardPoints = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [updateListData, setUpdateListData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10); // You can adjust this number as needed
  const [searchTerm, setSearchTerm] = useState("");
  const txtBSearch = useRef(null);
  const [isOpen, setIsOpen] = useState({
    reward_status: false,
    startDates: false,
  });
  const [sortOrder, setSortOrder] = useState("asc");
  const navigate = useNavigate();
  const [updateChipData, setUpdateChipData] = useState([]);

  const [reward_status, setReward_status] = useState([]);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);
  const [appOns, setAppOns] = useState([]);

  const [appDatas, setAppDatas] = useState({
    FDate: "",
    TDate: "",
    Days: "",
    name: "",
  });

  const filterRef = useRef(null);
  const filterLastRef = useRef(null);
  const fDatePickerRef = useRef(null);
  const tDatePickerRef = useRef(null);
  let filterSearch = [];
  const location = useLocation();
  const { filStatus, filter_search, filter_date } = location.state || {};
  const [csvData, setCsvData] = useState([]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        {
          const hasrwarad = updateChipData.some(
            (chipItem) => chipItem.type === "reward_status"
          );
          if (hasrwarad) {
            const updatedAuthor = updateChipData.filter(
              (chipItem) => chipItem.type === "reward_status"
            );
            setReward_status(updatedAuthor);
          } else {
            setReward_status([]);
          }
          setIsOpen((prev) => ({ ...prev, reward_status: false }));
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData]);
  let filterRewardStatus = [];
  let filterApplyeds = [];
  useEffect(() => {
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }, [searchTerm]);
  useEffect(() => {
    filterRewardStatus = reward_status;
  }, [reward_status]);
  useEffect(() => {
    filterApplyeds = appOns;
  }, [appDatas]);
  useEffect(() => {
    if (filStatus && filStatus.length > 0) {
      setReward_status(filStatus);
      filterRewardStatus = filStatus;
    } else {
      setReward_status(reward_status);
      filterRewardStatus = reward_status;
    }
    if (filter_date && filter_date.length > 0) {
      const filterDates = filter_date[0];
      setAppDatas({
        FDate: filterDates.fdate,
        TDate: filterDates.edate,
        Days: filterDates.Days,
        name: "",
      });
      setAppOns(filter_date);
      filterApplyeds = filter_date;
    }

    if (filter_search && filter_search.length > 0) {
      filterSearch = [{ name: "" + filter_search, type: "search" }];
      setSearchTerm(filter_search);
    } else {
      if (searchTerm) {
        // setSearchTerm(searchTerm);
        filterSearch = [{ name: "" + searchTerm, type: "search" }];
      }
    }
    setIsFiltersInitialized(true);
    loadChipdata();
  }, [filStatus, filter_search]);
  useEffect(() => {
    if (isFiltersInitialized && filStatus && filStatus.length > 0) {
      loadListdata();
    } else if (
      isFiltersInitialized &&
      filter_search &&
      filter_search.length > 0
    ) {
      loadListdata();
    } else if (isFiltersInitialized && filter_date && filter_date.length > 0) {
      loadListdata();
    }
  }, [
    filStatus,
    filter_search,
    filter_date,
    isFiltersInitialized,
    updateChipData,
  ]);
  useEffect(() => {
    if (isFiltersInitialized) {
      loadListdata();
    }
  }, [isFiltersInitialized, updateChipData]);
  useEffect(() => {
    if (location.state) {
      navigate(location.pathname, {
        replace: true,
        state: {},
      });
    }
  }, []);

  // Fetch Data from API
  function updateStateData() {
    filterRewardStatus = reward_status;
    filterApplyeds = appOns;
    if (searchTerm.length > 0) {
      filterSearch = [{ name: "" + searchTerm, type: "search" }];
    } else {
      filterSearch = [];
    }
  }
  // Handles Search Input and Updates Filter Chips
  const handleSearch = (event) => {
    if (event.key === "Enter") {
      let val = event.target.value;
      updateStateData();
      setSearchTerm(val);
      if (val.length > 0) {
        filterSearch = [{ name: "" + val, type: "search" }];
      } else {
        filterSearch = [];
      }
      loadChipdata();
    }
  };

  const handleCheckboxChange = (event, names, typename) => {
    const { name, value, checked } = event.target;
    if (typename === "reward_status") {
      if (checked) {
        setReward_status([
          ...reward_status,
          { id: value, name: name, type: "reward_status" },
        ]);
      } else {
        setReward_status(reward_status.filter((item) => item.id !== value));
      }
    }
  };
  // ------chipdata listitem------
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));
  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "reward_status") {
      loadChipdata();
      setCurrentPage(1);
      setIsOpen({
        ...isOpen,
        reward_status: false,
      });
    } else if (name === "appliedOns") {
      loadChipdata();
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }
  };
  const loadListdata = () => {
    let tempstatus = [];
    reward_status.map((obj) => {
      tempstatus.push(Number(obj.id));
    });
    const filters = {
      search: searchTerm.length > 0 ? searchTerm : "",
      status: reward_status.length > 0 ? tempstatus : "",
      start_date: appOns.length > 0 ? appOns[0].fdate || appOns[0].FDate : "",
      end_date: appOns.length > 0 ? appOns[0].edate || appOns[0].TDate : "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/book/reward_list", filters)
      .then((res) => {
        if (res.data.status) {
          setIsLoading(false);
          const fiata = res.data.data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          setCurrentPage(1);
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            description: item.description,
            point_per_hundred: item.point_per_hundred,
            amount_per_point: item.amount_per_point,
            amount_per_hundred: item.amount_per_hundred,
            validity_date: item.validity_date,
            status:
              item.status === 0
                ? "Expired"
                : item.status === 1
                ? "Active"
                : "Upcoming",
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setUpdateListData(serialNumberAddedData);
        } else if (res.data.status === false) {
          setUpdateListData([]);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        setUpdateListData([]);
        setIsLoading(false);
        console.error("Error loading data:", error);
      });
  };

  function loadChipdata() {
    let tempArr = [];
    filterSearch.map((obj) => {
      tempArr.push(obj);
    });
    filterRewardStatus.map((obj) => {
      tempArr.push(obj);
    });
    filterApplyeds.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }

  // filter clear button
  const handleClear = (name) => {
    const updatedChips = updateChipData.filter((item) => item.type !== name);
    setUpdateChipData(updatedChips);
    setIsOpen({
      reward_status: false,
    });
    if (name === "reward_status") {
      updateStateData();
      setReward_status([]);
      filterRewardStatus = [];
    } else if (name === "appliedOns") {
      updateStateData();
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
      setIsOpen({
        ...isOpen,
        startDates: false,
      });
    }

    setTimeout(() => {
      loadChipdata();
    }, 500);
  };

  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "search") {
      setSearchTerm("");
      filterSearch = [];
    } else if (chipToDelete.type === "reward_status") {
      setReward_status(
        reward_status.filter((item) => item.id !== chipToDelete.id)
      );
      filterRewardStatus = reward_status.filter(
        (item) => item.id !== chipToDelete.id
      );
    } else if (chipToDelete.type === "dayRanges") {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    } else {
      setAppDatas({
        FDate: "",
        TDate: "",
        Days: "",
      });
      setAppOns([]);
      filterApplyeds = [];
    }
    loadChipdata();
  };
  const handleFilter = (e, boxName) => {
    if (boxName === "reward_status") {
      setIsOpen((prevState) => ({
        type: false,
        reward_status: !prevState.reward_status,
      }));
      setReward_status(
        updateChipData.filter((ui) => ui.type === "reward_status")
      );
    } else if (boxName === "appliedOn") {
      setIsOpen((prevState) => ({
        type: false,
        section: false,
        status: false,
        payment_type: false,
        category_code: false,
        location_name: false,
        course_name: false,
        batch_name: false,
        startDates: !prevState.startDates,
      }));
    }
  };
  const handleAllClear = () => {
    setSearchTerm([]);
    setUpdateChipData([]);
    setReward_status([]);
    setAppOns([]);
    setAppDatas({
      FDate: "",
      TDate: "",
      Days: "",
    });
  };

  const handleSearchFocus = () => {
    if (txtBSearch.current) {
      txtBSearch.current.focus();
      // Create a new KeyboardEvent
      const event = new KeyboardEvent("keydown", {
        key: "Enter",
        keyCode: 13,
        which: 13,
        code: "Enter",
        bubbles: true,
      });
      // Dispatch the event
      txtBSearch.current.dispatchEvent(event);
    }
  };
  // total table data  with pages
  const totalPages = Math.ceil(updateListData?.length / rowsPerPage);
  // prev button pagination
  const handlePrev = (val) => {
    setCurrentPage(val);
  };
  // next button pagination
  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
    setUpdateListData([]);
    loadListdata();
  };
  // pagination start end -   item per page changing
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  // const currentData = csvListData.slice(start, end);
  const currentData = updateListData?.slice(start, end);
  // Sorting Handler
  const handleSort = (event, sortKey) => {
    event.preventDefault();
    let order = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(order);
    let sortedList = updateListData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setUpdateListData(sortedList);
  };

  const handleReadView = (id) => {
    const formattedAppOns = appOns.map((item) => ({
      name:
        item.name ||
        (item.FDate && item.TDate ? `${item.FDate} - ${item.TDate}` : ""),
      fdate: item.fdate || item.FDate,
      edate: item.edate || item.TDate,
      type: item.type || "dateRange",
    }));
    navigate(`/ViewRewardPoints/${id}`, {
      state: {
        STATUS: reward_status,
        SEARCH: searchTerm,
        DATE: formattedAppOns,
      },
    });
  };
  const generatePDF = () => {
    const headers = [
      // "S.No",
      "Description",
      "Points per 100",
      "Amount Per Point",
      "Amount Per 100",
      "Validity Date",
      "Status",
    ];
    const rows = csvData.map((item, index) => [
      // index + 1,
      item.description ?? "",
      item.point_per_hundred ?? "",
      item.amount_per_point ?? "",
      item.amount_per_hundred ?? "",
      item.validity_date ?? "",
      item.status ?? "",
    ]);
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Reward Points Data",
          headers,
          rows,
          filename: "RewardPoints.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const handleChangeDate_app = (date, name) => {
    const dateFilter = moment(date).format("YYYY-MM-DD");
    if (name === "FDate" || name === "TDate") {
      setAppDatas((prevState) => {
        const updated = {
          ...prevState,
          [name]: dateFilter,
          Days: "",
        };
        const from = name === "FDate" ? dateFilter : updated.FDate;
        const to = name === "TDate" ? dateFilter : updated.TDate;
        if (from && to) {
          const dateRange = `${from} - ${to}`;
          setAppOns([
            {
              name: dateRange,
              fdate: moment(from).format("YYYY-MM-DD"),
              edate: moment(to).format("YYYY-MM-DD"),
              type: "dateRange",
              Days: "",
            },
          ]);
        }

        return updated;
      });
    }
  };

  const csvHeaders = [
    { label: "Serial Number", key: "serialNumber" },
    { label: "Description", key: "description" },
    { label: "Points per 100", key: "point_per_hundred" },
    { label: "Amount per Point", key: "amount_per_point" },
    { label: "Amount per 100", key: "amount_per_hundred" },
    { label: "Validity Date", key: "validity_date" },
    { label: "Status", key: "status" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div
      className={`${ListInfo.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid BathDet global_container p-0`}
    >
      <div className={`${styles.cm_container} BathHeader`}>
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">Reward Points</h2>
        </div>

        <div className="row">
          <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12 mb-2">
            <div className="input-group">
              <input
                ref={txtBSearch}
                type="text"
                class={styles.Inputs}
                // class={styles.Inputs}
                // className="form-control"
                id="SearchInput"
                name="SearchInput"
                placeholder="Search by description"
                onKeyDown={handleSearch}
              />
              <span
                class={styles.input_group_text}
                id="SearchInput"
                onClick={handleSearchFocus}
              >
                <span className="material-icons">search</span>
              </span>
            </div>
          </div>

          <div className="col-md-8 col-12 ListBtn">
            <ul className="List-Button">
              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData?.length > 0 ? csvData : ""}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"Rewardpoints.csv"}
                  csvName="  Download as CSV"
                />
              </li>
              <li class="ListBtnItems primaryButton" onClick={generatePDF}>
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                Download as PDF
              </li>
              <li className="ListBtnItems">
                <Link to="/CreateRewardPoints" className="primaryButton">
                  Create New Reward Point
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {updateChipData.filter((kl) => kl.name !== "ActiveTab").length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global ">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData
                  .filter((kl) => kl.name !== "ActiveTab")
                  .map((data, index) => {
                    let icon;
                    let key = "" + data.name;
                    return (
                      <ListItem key={data}>
                        <Chip
                          icon={icon}
                          label={key}
                          onDelete={handleDelete(data, index)}
                        />
                      </ListItem>
                    );
                  })}

                <ListItem className="clearAll_list">
                  <a
                    className="clearAll_listItem"
                    href="javascript:void(0)"
                    onClick={handleAllClear}
                  >
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}

        {/* Table Section */}
        <div className="row mx-0 mt-2">
          <div className="col-md-12 table-responsive tableMinHeight px-0">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  {/* S.No */}
                  <th id="th">
                    <span className="textHead_th">S.No</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Description */}
                  <th id="th">
                    <span className="textHead_th">Description</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "description")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Points per ₹100  */}
                  <th id="th">
                    <span className="textHead_th">Points per ₹100</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "point_per_hundred")}
                    >
                      import_export
                    </span>
                  </th>

                  {/* Amount Per Point */}
                  <th id="th">
                    <span className="textHead_th">Amount Per Point</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "amount_per_point")}
                    >
                      import_export
                    </span>
                  </th>
                  {/* Amount Per ₹100 */}
                  <th id="th">
                    <span className="textHead_th">Amount Per ₹100</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "amount_per_hundred")}
                    >
                      import_export
                    </span>
                  </th>

                  {/* Display Date */}
                  <th id="th">
                    <span className="textHead_th">Validity Date</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "validity_date")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th" ref={filterLastRef}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "created_dt")}
                    >
                      {" "}
                      Created Date
                    </span>
                    <span
                      className={`material-icons textHead_th align-middle`}
                      onClick={(e) => handleSort(e, "created_dt")}
                    >
                      import_export
                    </span>{" "}
                    <span
                      onClick={(e) => handleFilter(e, "appliedOn")}
                      class={` align-middle material-icons ${
                        (appDatas &&
                          Object.entries(appDatas).some(
                            ([key, val]) =>
                              key !== "name" &&
                              val !== null &&
                              val !== undefined &&
                              val.toString().trim() !== ""
                          )) ||
                        isOpen.appliedOn
                          ? ListInfo.active_icons
                          : ""
                      }`}
                    >
                      filter_list
                    </span>
                    {isOpen.startDates === true && (
                      <div className="filterBoxs_testlist container mt-2   p-1">
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <div class="form-check p-1">
                              <label
                                htmlFor="FDate"
                                className="d-flex form-label"
                              >
                                From Date
                                <span
                                  data-required="true"
                                  aria-hidden="true"
                                ></span>
                              </label>
                              {/* <input
                                                                                 /> */}
                              <DatePickerSample
                                IconInput={"filterIocnBoxInput"}
                                class={"FilterInputs"}
                                name={"FDate"}
                                handleChange={handleChangeDate_app}
                                fieldInput={appDatas.FDate}
                                txtAdMDob={fDatePickerRef}
                                // maxDate={new Date()}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row mt-1">
                          <div className="col-md-12">
                            <div class="form-check p-1">
                              <label
                                htmlFor="TDate "
                                className="d-flex form-label"
                              >
                                To Date
                                <span
                                  data-required="true"
                                  aria-hidden="true"
                                ></span>
                              </label>
                              {/* <input
                                                                                 /> */}
                              <DatePickerSample
                                class={"FilterInputs"}
                                IconInput={"filterIocnBoxInput"}
                                name={"TDate"}
                                handleChange={handleChangeDate_app}
                                fieldInput={appDatas.TDate}
                                txtAdMDob={tDatePickerRef}
                                minDate={appDatas.FDate}
                              />
                            </div>
                          </div>
                        </div>
                        {/* <div className="row mt-2">
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                id="Today"
                                value="Today"
                                checked={appDatas.Days === "Today"}
                                onChange={handleAppliedOns}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Today"
                                htmlFor="Today"
                                style={{ fontWeight: "bold" }}
                              >
                                Today
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                value="Yesterday"
                                checked={appDatas.Days === "Yesterday"}
                                id="Yesterday"
                                onChange={handleAppliedOns}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Yesterday"
                                htmlFor="Yesterday"
                                style={{ fontWeight: "bold" }}
                              >
                                Yesterday
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                value="Tweek"
                                checked={appDatas.Days === "Tweek"}
                                id="Tweek"
                                onChange={handleAppliedOns}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Tweek"
                                htmlFor="Tweek"
                                style={{ fontWeight: "bold" }}
                              >
                                This week
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                value="Lweek"
                                checked={appDatas.Days === "Lweek"}
                                id="Lweek"
                                onChange={handleAppliedOns}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Lweek"
                                htmlFor="Lweek"
                                style={{ fontWeight: "bold" }}
                              >
                                Last week
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                value="Tmonth"
                                checked={appDatas.Days === "Tmonth"}
                                id="Tmonth"
                                onChange={handleAppliedOns}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Tmonth"
                                htmlFor="Tmonth"
                                style={{ fontWeight: "bold" }}
                              >
                                This month
                              </label>
                            </div>
                          </div>
                          <div className="col-md-6 col-6 col-sm-6 col-xs-6">
                            <div class="form-check">
                              <input
                                class="form-check-input"
                                type="radio"
                                name="Days"
                                checked={appDatas.Days === "Lmonth"}
                                value="Lmonth"
                                id="Lmonth"
                                onChange={handleAppliedOns}
                              />
                              <label
                                class="form-check-label d-flex"
                                for="Lmonth"
                                htmlFor="Lmonth"
                                style={{ fontWeight: "bold" }}
                              >
                                Last month
                              </label>
                            </div>
                          </div>
                        </div> */}
                        <hr />
                        <div className="row mt-3">
                          <div className="col-md-4  col-4 col-sm-4">
                            <span
                              className="clearFilter ms-2 "
                              style={{ cursor: "pointer" }}
                              onClick={() => handleClear("appliedOns")}
                            >
                              Clear
                            </span>
                          </div>
                          <div className="col-md-8  col-8 col-sm-8">
                            <button
                              className="FilterButton"
                              onClick={() => handleApplyFilter("appliedOns")}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </th>
                  {/* Status */}
                  <th id="th" ref={filterRef}>
                    <span
                      className="textHead_th"
                      onClick={(e) => handleSort(e, "status")}
                    >
                      Status
                    </span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "status")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        reward_status.length > 0 || isOpen.reward_status
                          ? ListInfo.active_icons
                          : ""
                      } `} // Change here
                      onClick={(e) => handleFilter(e, "reward_status")}
                    >
                      filter_list
                    </span>
                    {isOpen.reward_status === true && (
                      <div className="filterBoxs_testlist">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Expired"}
                                value={"0"}
                                checked={reward_status.some((element) => {
                                  if (element.id == "0") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Expired"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "reward_status",
                                    "reward_status"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText bg-danger"
                                htmlFor={"Expired"}
                              >
                                Expired
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Active"}
                                value={"1"}
                                checked={reward_status.some((element) => {
                                  if (element.id == "1") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Active"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "reward_status",
                                    "reward_status"
                                  )
                                }
                              />
                              <label
                                className="form-check-label filterChipText bg-green"
                                htmlFor={"Active"}
                              >
                                Active
                              </label>
                            </li>

                            <li className="filterListData">
                              <input
                                className="ListCheckbox"
                                type="checkbox"
                                name={"Upcoming"}
                                value={"2"}
                                checked={reward_status.some((element) => {
                                  if (element.id == "2") {
                                    return true;
                                  }
                                  return false;
                                })}
                                id={"Upcoming"}
                                onChange={(e) =>
                                  handleCheckboxChange(
                                    e,
                                    "reward_status",
                                    "reward_status"
                                  )
                                }
                              />
                              <label
                                className="form-check-label bg-orange filterChipText  "
                                htmlFor={"Upcoming"}
                              >
                                Upcoming
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() => handleClear("reward_status")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                to={"javascript:void(0)"}
                                onClick={() =>
                                  handleApplyFilter("reward_status")
                                }
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>
                  {/* Action */}
                  <th id="th" className={style.tableThPadding}>
                    <span className="textHead_th">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentData.length === 0 ? (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentData.map((course, index) => (
                    <tr key={index}>
                      {/* <td id="td">
                        {(currentPage - 1) * rowsPerPage + index + 1}
                      </td> */}
                      <td id="id">{course.serialNumber}</td>
                      <td id={`${styles.td}tabTh`}>
                        <span
                          className={style.ellipsisText}
                          title={course.description}
                        >
                          {course.description}
                        </span>
                      </td>
                      <td id="td">{course.point_per_hundred}</td>
                      <td id="td">{course.amount_per_point}</td>
                      <td id="td">{course.amount_per_hundred}</td>
                      <td id="td">
                        <span>{course.validity_date}</span>
                      </td>
                      <td id="td">
                        {moment(course.created_dt).utc().format("DD/MM/YYYY")}
                      </td>
                      {/* <td id="id">{course.status}</td> */}
                      {course.status == 0 && (
                        <td id={`${styles.td}`}>
                          <span class="filterChipText bg-danger mx-0 ">
                            Expired
                          </span>
                        </td>
                      )}
                      {course.status == 1 && (
                        <td id={`${styles.td}`}>
                          <span class="filterChipText bg-green mx-0 ">
                            Active
                          </span>
                        </td>
                      )}
                      {course.status == 2 && (
                        <td id={`${styles.td}`}>
                          <span class="filterChipText bg-orange mx-0">
                            Upcoming
                          </span>
                        </td>
                      )}
                      <td id="td">
                        <img
                          src={ViewIcon}
                          className={`{style.cursor_pointer} px-2 material-icons`}
                          alt="view icon"
                          onClick={(e) => handleReadView(course.id)}
                        />
                        {/* <button
                          className={"view_icon_button"}
                          onClick={() => handleReadView(course.id)}
                        >
                          <span className={` visibleicon material-icons`}>
                            visibility
                          </span>
                        </button> */}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        {/* Pagination */}
        <div className="row mt-2">
          <Pagination
            rowsPerPage={rowsPerPage}
            handlePageCount={handlePageCount}
            startPage={
              updateListData && updateListData?.length > 0
                ? currentPage * rowsPerPage + 1 - rowsPerPage
                : 0
            }
            endPage={
              updateListData && updateListData?.length > 0
                ? updateListData?.length < currentPage * rowsPerPage
                  ? updateListData?.length
                  : currentPage * rowsPerPage
                : 0
            }
            totalRecords={
              updateListData && updateListData?.length > 0
                ? updateListData?.length
                : 0
            }
            handlePrev={(e) => handlePrev(currentPage - 1)}
            currentPrevPage={currentPage === 1}
            prevButton={`${ListInfo.prev_buttonViewEvaluator} ${ListInfo.materialIconsRightAndLeft} me-2`}
            handleNext={() => handleNext(currentPage + 1)}
            currentNextPage={currentPage === totalPages || totalPages == 0}
          />
        </div>
      </div>
    </div>
  );
};

export default RewardPoints;
